<div mat-dialog-content>
    <p>Do you really want to Cancel? If you click "Yes" you will lose the data you entered.</p>
</div>
<div mat-dialog-actions>
    <button  mat-flat-button type="button" color="primary" [mat-dialog-close]="true">Yes</button>
    <button mat-flat-button type="button" color="primary" [mat-dialog-close]="false">No</button>
</div>